import { Breakpoints } from '@apps/gated-2021/breakpoints';
import { Colors } from '@src/colors';
import styled from 'styled-components';

export const ChartPreview = styled.div`
    border-radius: 30px;
    background: ${Colors.midnight2};
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    width: 504px;
    height: 500px;
    padding: 81px 55px 72px 55px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 27px;
    margin: auto 0;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        display: none;
    }
`;

export const Title = styled.h5`
    font-family: 'Public Sans';
    font-size: 28px;
    font-weight: 800;
    line-height: 33px;
    text-align: center;
    letter-spacing: -0.2px;
    color: ${Colors.midnight};
`;

export const BoxWithDashes = styled.div`
    width: 235px;
    height: 60px;
    background: ${Colors.midnight2};
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
    border-radius: 8px;

    & > p {
        color: ${Colors.midnight};
        font-family: 'Public Sans';
        font-size: 50px;
        line-height: 59px;
        text-align: center;
    }
`;

export const BarGraphPreview = styled.div`
    height: 225px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    opacity: 0.7;
    filter: blur(8px);
`;

export const GraphBars = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-evenly;
    gap: 16px;
    padding: 0 5px;
`;

export const Bar = styled.div<{
    color: Colors.midnight | Colors.midnight40;
    heightPercentage: number;
}>`
    width: 20px;
    height: ${(p) => p.heightPercentage}%;
    background-color: ${(p) => p.color};
`;

export const HorizontalFooterBar = styled.div`
    width: 100%;
    height: 5px;
    background-color: ${Colors.midnight70};
`;
